import {ApiFilters, ApiPaging, ApiSortings} from './api';

export const BILLING_TYPES = ['CREDIT', 'DEBIT'] as const;
export type BillingType = typeof BILLING_TYPES[number];

export const BILLING_INVOICE_STATUS = [
    'SENT',
    'PAID',
    'PARTIALLY_PAID',
    'CANCELLED',
    'CLOSED',
    'WRITTEN_OFF',
    'OVERDUE',
] as const;
export type BillingInvoiceStatus = typeof BILLING_INVOICE_STATUS[number];

export interface BillingRawRow {
    id: number;
    transactionType: BillingType;
    documentNumber: string;
    description: string;
    amount: number;
    operationDate: string;
}

export interface BillingInvoiceRawRow {
    id: string;
    irn: string;
    client: {
        tin: string;
        email: string;
    } | null;
    issueDate: string;
    issueTime?: string;
    totalInvoicedQuantity: number;
    payableAmount: number;
    status: BillingInvoiceStatus;
}

export interface BillingPageableContent<C extends Record<string, any>> {
    data: C[];
    totalElements: number;
    totalPages: number;
}
export interface BillingInvoicePageableContent {
    content: BillingInvoiceRawRow[];
    totalElements: number;
    totalPages: number;
}

export interface BillingHistoryRequest {
    legalIdentityId?: number | null;
    paging: ApiPaging;
    filters?: ApiFilters;
    sortings?: ApiSortings;
    searchById?: string | null;
    searchByTin?: string | null;
    searchByIrn?: string | null;
}

export interface BillingBalance {
    id: number;
    legalIdentityId: number;
    currentBalance: number;
    createdAt: string;
    updatedAt: string;
}

export interface BillingDebitRequest {
    legalIdentityId: number;
    amount: number;
    documentNumber: string;
    bankTransactionNumber: string;
}

export interface BillingCreditRequest {
    legalIdentityId: number;
    orderId: string;
    amount: number;
}

export enum BillingHistoryAccessors {
    id = 'id',
    transactionType = 'transactionType',
    documentNumber = 'documentNumber',
    description = 'description',
    amount = 'amount',
    operationDate = 'operationDate',
    action = 'action',
}

export enum BillingInvoicesAccessors {
    irn = 'irn',
    tin = 'tin',
    issueDate = 'issueDate',
    totalInvoicedQuantity = 'totalInvoicedQuantity',
    payableAmount = 'payableAmount',
    status = 'status',
}

export interface ChangeInvoiceStatusRequest {
    docNumber: string;
    irn: string;
    email: string;
    tin: string;
}
